var React = require('react');

function StatusIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.40041 7.849L6.83361 12.9411C6.63995 13.5705 6.05845 14 5.39994 14H3C2.44772 14 2 13.5523 2 13C2 12.4477 2.44772 12 3 12H5.03066L7.03577 5.48336C7.48669 4.01786 9.58625 4.09317 9.93103 5.5872L12.4009 16.29L13.4755 13.0303C13.6782 12.4154 14.2526 12 14.9001 12H21C21.5523 12 22 12.4477 22 13C22 13.5523 21.5523 14 21 14H15.2617L13.7404 18.6146C13.2653 20.0559 11.1955 19.9609 10.8542 18.4823L8.40041 7.849Z","fill":"#E8EFFF"})));
}

StatusIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = StatusIcon;

StatusIcon.default = StatusIcon;
